(function () {
  var ENDPOINT = 'https://api.leestafford.com/wishlist.php';
  var GUEST_KEY = 'ls_wishlist';

  function getStore() {
    return window.wishlistStore || 'uk';
  }

  function isLoggedIn() {
    return !!window.wishlistCustomerId;
  }

  function updateHeaderCount(count) {
    var badge = document.querySelector('[data-wishlist-count]');
    if (!badge) return;
    var wasHidden = badge.hidden;
    if (count > 0) {
      badge.textContent = count;
      badge.hidden = false;
      if (!wasHidden) {
        badge.classList.remove('is-animating');
        // Force reflow so the animation can restart
        void badge.offsetWidth;
        badge.classList.add('is-animating');
        setTimeout(function () {
          badge.classList.remove('is-animating');
        }, 400);
      }
    } else {
      badge.hidden = true;
    }
  }

  function animateHeart(btn) {
    btn.classList.remove('is-animating');
    void btn.offsetWidth;
    btn.classList.add('is-animating');
    setTimeout(function () {
      btn.classList.remove('is-animating');
    }, 400);
  }

  function setButtonState(btn, isWishlisted) {
    btn.classList.toggle('is-wishlisted', isWishlisted);
    btn.setAttribute('aria-pressed', isWishlisted ? 'true' : 'false');
    btn.setAttribute(
      'aria-label',
      isWishlisted ? 'Remove from wishlist' : 'Add to wishlist'
    );
    btn.setAttribute(
      'title',
      isWishlisted ? 'Remove from Wishlist' : 'Add to Wishlist'
    );
    var label = btn.querySelector('.wishlist-btn__label');
    if (label) {
      label.textContent = isWishlisted ? 'Remove from Wishlist' : 'Add to Wishlist';
    }
  }

  function removeCardAndMaybeShowEmpty(btn) {
    var card = btn.closest('[data-wishlist-item]');
    if (!card) return;

    card.classList.add('is-removing');
    setTimeout(function () {
      card.remove();
      var grid = document.querySelector('[data-guest-wishlist-grid]');
      var empty = document.querySelector('[data-guest-wishlist-empty]');
      if (grid && grid.children.length === 0) {
        grid.hidden = true;
        if (empty) empty.hidden = false;
      }
    }, 250);
  }

  // ---- Guest (localStorage) wishlist ----

  function getGuestList() {
    try {
      var raw = window.localStorage.getItem(GUEST_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function setGuestList(list) {
    try {
      window.localStorage.setItem(GUEST_KEY, JSON.stringify(list));
    } catch (e) {
      // localStorage unavailable (private mode, etc.) - fail silently
    }
    updateHeaderCount(list.length);
  }

  function guestIndexOf(list, productId) {
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].id) === String(productId)) return i;
    }
    return -1;
  }

  function isGuestWishlisted(productId) {
    return guestIndexOf(getGuestList(), productId) !== -1;
  }

  function toggleGuestItem(btn) {
    var productId = btn.getAttribute('data-product-id');
    var list = getGuestList();
    var index = guestIndexOf(list, productId);
    var wishlisted;

    if (index === -1) {
      list.push({
        id: productId,
        handle: btn.getAttribute('data-product-handle'),
        title: btn.getAttribute('data-product-title'),
        url: btn.getAttribute('data-product-url'),
        image: btn.getAttribute('data-product-image'),
        price: btn.getAttribute('data-product-price'),
      });
      wishlisted = true;
    } else {
      list.splice(index, 1);
      wishlisted = false;
    }

    setGuestList(list);
    setButtonState(btn, wishlisted);
    animateHeart(btn);

    if (!wishlisted) {
      removeCardAndMaybeShowEmpty(btn);
    }
  }

  function applyGuestStateToButtons() {
    var list = getGuestList();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var productId = btn.getAttribute('data-product-id');
      setButtonState(btn, guestIndexOf(list, productId) !== -1);
    });
    updateHeaderCount(list.length);
  }

  function syncButtonsWithin(node) {
    var list = getGuestList();
    var sync = function (btn) {
      setButtonState(btn, guestIndexOf(list, btn.getAttribute('data-product-id')) !== -1);
    };
    if (node.matches && node.matches('[data-wishlist-toggle]')) sync(node);
    if (node.querySelectorAll) {
      node.querySelectorAll('[data-wishlist-toggle]').forEach(sync);
    }
  }

  // Dynamically-injected content (quick view, lazy-loaded recommendations,
  // ajax search results, etc.) renders server-side with logged-out state.
  // Watch for it and sync guest wishlist state as it appears.
  function observeDynamicContent() {
    if (!('MutationObserver' in window)) return;
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          syncButtonsWithin(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function fetchProductCard(item) {
    if (!item.handle) return Promise.resolve(null);
    return fetch('/products/' + item.handle)
      .then(function (res) {
        return res.ok ? res.text() : null;
      })
      .then(function (html) {
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var card = doc.querySelector('#wishlist-card-render-output .inner-product');
        return card ? card.cloneNode(true) : null;
      })
      .catch(function () {
        return null;
      });
  }

  function renderGuestWishlistPage() {
    var grid = document.querySelector('[data-guest-wishlist-grid]');
    var empty = document.querySelector('[data-guest-wishlist-empty]');
    if (!grid) return;

    var list = getGuestList();
    grid.innerHTML = '';

    if (list.length === 0) {
      grid.hidden = true;
      if (empty) empty.hidden = false;
      return;
    }

    if (empty) empty.hidden = true;
    grid.hidden = false;

    list.forEach(function (item) {
      fetchProductCard(item).then(function (card) {
        var wrapper = document.createElement('div');
        wrapper.className = 'product-grid__item';
        wrapper.setAttribute('data-wishlist-item', '');
        wrapper.appendChild(
          card ||
            (function () {
              var fallback = document.createElement('a');
              fallback.href = item.url || '#';
              fallback.textContent = item.title || '';
              return fallback;
            })()
        );
        grid.appendChild(wrapper);

        // The rendered button reflects server-side (logged-out) state; force it wishlisted.
        var btn = wrapper.querySelector('[data-wishlist-toggle]');
        if (btn) setButtonState(btn, true);
      });
    });
  }

  // ---- Guest -> account merge on login ----

  function mergeGuestIntoAccount() {
    if (!isLoggedIn()) return;
    var list = getGuestList();
    if (list.length === 0) return;

    var ids = list.map(function (item) { return item.id; }).join(',');
    var params = new URLSearchParams({
      action: 'merge',
      store: getStore(),
      customer_id: window.wishlistCustomerId,
      product_ids: ids,
    });

    fetch(ENDPOINT + '?' + params.toString(), { method: 'POST' })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.success) {
          setGuestList([]);
          window.location.reload();
        }
      })
      .catch(function () {
        // Leave guest items in localStorage; will retry merge on next page load
      });
  }

  // ---- Click handling ----

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;

    if (!isLoggedIn()) {
      toggleGuestItem(btn);
      return;
    }

    btn.disabled = true;

    var productId = btn.getAttribute('data-product-id');
    var wasWishlisted = btn.classList.contains('is-wishlisted');

    // Optimistic UI update
    setButtonState(btn, !wasWishlisted);

    var params = new URLSearchParams({
      action: 'toggle',
      store: getStore(),
      customer_id: window.wishlistCustomerId,
      product_id: productId,
    });

    fetch(ENDPOINT + '?' + params.toString(), { method: 'POST' })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        btn.disabled = false;
        if (!data.success) {
          setButtonState(btn, wasWishlisted);
          return;
        }
        setButtonState(btn, data.wishlisted);
        animateHeart(btn);
        updateHeaderCount(data.count);

        // If on the wishlist page and item removed, remove its card
        if (!data.wishlisted) {
          removeCardAndMaybeShowEmpty(btn);
        }
      })
      .catch(function () {
        btn.disabled = false;
        setButtonState(btn, wasWishlisted);
      });
  });

  // ---- Init ----

  document.addEventListener('DOMContentLoaded', function () {
    if (isLoggedIn()) {
      mergeGuestIntoAccount();
    } else {
      applyGuestStateToButtons();
      renderGuestWishlistPage();
      observeDynamicContent();
    }
  });
})();
